import { userOptionsStore } from '~/shared/api'

export const usePermissions = () => {
  const permissions = userOptionsStore.permissions || []
  const checkPermissions = (permission: string) =>
    permissions.includes(permission)

  const canUsersUpdate = checkPermissions('update users')
  const canUsersView = checkPermissions('view users')

  const canRolesUpdate = checkPermissions('update roles')
  const canRolesView = checkPermissions('view roles')

  const canAuditsView = checkPermissions('view audits')

  const canMassMailingUpdate = checkPermissions('update mass mailings')
  const canMassMailingView = checkPermissions('view mass mailings')
  const canMassMailingDelete = checkPermissions('delete mass mailings')

  const canSettingsView = canUsersView || canRolesView

  return {
    canUsersUpdate,
    canUsersView,
    canRolesUpdate,
    canRolesView,
    canAuditsView,
    canSettingsView,
    canMassMailingUpdate,
    canMassMailingView,
    canMassMailingDelete,
  }
}
